import { useEffect, useState } from "react";
import { Bell, Check, ArrowRight, SignIn, SignOut } from "@phosphor-icons/react";
import { http } from "@/lib/api";
import { toast } from "sonner";

export default function AlertsFeed({ alerts: initialAlerts, onRefresh }) {
  const [alerts, setAlerts] = useState(initialAlerts || []);

  useEffect(() => {
    setAlerts(initialAlerts || []);
  }, [initialAlerts]);

  const ack = async (id) => {
    try {
      await http.post(`/alerts/${id}/ack`);
      setAlerts((prev) => prev.filter((a) => a.id !== id));
      toast.success("Alert acknowledged");
      onRefresh && onRefresh();
    } catch (e) {
      toast.error("Failed to acknowledge");
    }
  };

  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="bg-black/70 backdrop-blur-xl border border-[#ff8c00]/40 w-[320px] max-h-[35vh] flex flex-col" data-testid="alerts-feed">
      <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between bg-[#ff8c00]/10">
        <div className="flex items-center gap-2">
          <Bell size={14} weight="fill" className="text-[#ff8c00] ll-status-blink" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#ff8c00] font-bold">Geofence Alerts</div>
            <div className="text-[10px] uppercase tracking-wider text-[#a1a1aa]">{alerts.length} unacknowledged</div>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {alerts.map((a) => (
          <div key={a.id} className="px-4 py-2.5 border-b border-white/5 flex items-center gap-2" data-testid={`alert-${a.id}`}>
            <div className="text-[#ff8c00]">
              {a.event === "entry" ? <SignIn size={14} weight="bold" /> : <SignOut size={14} weight="bold" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-mono font-bold truncate">
                {a.asset_name} <ArrowRight size={10} className="inline mx-1 text-[#71717a]" /> {a.zone_name}
              </div>
              <div className="text-[9px] uppercase tracking-wider text-[#71717a]">
                {a.event} · {new Date(a.created_at).toLocaleTimeString()}
              </div>
            </div>
            <button
              onClick={() => ack(a.id)}
              className="w-7 h-7 border border-[#22c55e] text-[#22c55e] hover:bg-[#22c55e] hover:text-black flex items-center justify-center transition-colors"
              data-testid={`ack-${a.id}`}
              title="Acknowledge"
            >
              <Check size={12} weight="bold" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
